import { httpClient } from "#src/HttpClient.js";
import { useInstanceSettingsStore } from "#src/stores/instance-settings.js";
import { setApprovedDomainFromRequest } from "#src/structures/ApprovedDomain.js";
import { OverridePrefillBehavior } from "#src/structures/OverridePrefillBehavior.js";

export class HttpBootService {
  #pinia;
  #baseUrl;
  #httpClient;

  constructor(pinia) {
    this.#pinia = pinia;
    const instance = useInstanceSettingsStore(this.#pinia);
    this.#baseUrl = `${instance.api_url}/strife/v1/boot`;
    this.#httpClient = httpClient(this.#pinia);
  }

  async getInstanceConfig({
    domain_key,
    npn,
    url,
    with_archived,
    eapp_id,
    eapp_uuid,
    case_id,
    case_uuid,
    referrer_id,
    referrer_type,
    referral_uid,
  }) {
    const params = {};

    if (domain_key) params.domain_key = domain_key;
    if (npn) params.npn = npn;
    if (url) params.url = url;
    if (with_archived) params.with_archived = with_archived;
    if (eapp_id && eapp_uuid) {
      params.eapp_id = eapp_id;
      params.eapp_uuid = eapp_uuid;
    }
    if (case_id && case_uuid) {
      params.case_id = case_id;
      params.case_uuid = case_uuid;
    }
    if (referrer_id && referrer_type) {
      params.referrer_id = referrer_id;
      params.referrer_type = referrer_type;
    }
    if (referral_uid) {
      params.referral_uid = referral_uid;
    }

    const headers = {};

    if (npn) headers["X-STRIFE-ID"] = npn;
    if (domain_key) headers["X-STRIFE-KEY"] = domain_key;

    const response = await this.#httpClient.get(this.#baseUrl, {
      params,
      headers,
    });

    return {
      approvedDomain: setApprovedDomainFromRequest(
        response.data.approved_domain
      ),
      overridePrefillBehavior: OverridePrefillBehavior(
        response.data.prefill_overrides
      ),
    };
  }
}
